import React from "react";
import Index from "./Index";

const History = () => {
  return <Index forcedTab="history" />;
};

export default History;
